import { PinnedUserBadgeComponent } from './../../../app/shared-components/pinned-user-badge/pinned-user-badge.component';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { Component, OnInit } from '@angular/core';
import { NgdAnalytics } from './@theme/services/analytics.service';
import { RouterOutlet } from '@angular/router';
import { ApiService } from '../../../app/services/api/api.service';

@Component({
    selector: 'ngd-app-root',
    template: `
    <router-outlet></router-outlet>
    <pinned-user-badge></pinned-user-badge>
  `,
    standalone: true,
    imports: [RouterOutlet, PinnedUserBadgeComponent],
})
export class NgdAppComponent implements OnInit {

  constructor(private analytics: NgdAnalytics, private api: ApiService) {
    this.api.setMe();
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
  }
}
